import React from 'react'

const SortBy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <g>
      <g transform="translate(-1095 -131)">
        <g>
          <g transform="translate(408 100)">
            <g>
              <g transform="translate(684 26)">
                <g transform="translate(3 5.5)">
                  <path className="st0" d="M.9 12.8h26.6c.5 0 .9.4.9.9s-.4.9-.9.9H.9c-.5 0-.9-.4-.9-.9s.4-.9.9-.9z" />
                  <path className="st0" d="M.9 3.9h26.6c.5 0 .9.4.9.9s-.4.9-.9.9H.9c-.5 0-.9-.4-.9-.9s.4-.9.9-.9z" />
                  <path className="st0" d="M.9 21.6h26.6c.5 0 .9.4.9.9s-.4.9-.9.9H.9c-.5 0-.9-.4-.9-.9s.4-.9.9-.9z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default SortBy
